import React, { Fragment } from 'react';
import { Typography, Divider, makeStyles, Grid } from '@material-ui/core';
import SimpleText from './SimpleText';
import SimplePassword from './SimplePassword';
import SimpleDropdown from './SimpleDropdown';
import SimpleChipDropdown from './SimpleChipDropdown';
import SimpleDropdownRequest from './SimpleDropdownRequest';
import SimpleDate from './SimpleDate';
import SimpleDateTime from './SimpleDateTime';
import SimpleAutocomplete from './SimpleAutocomplete';
import SimpleCheckbox from './SimpleCheckbox';
import SimpleTimePicker from './SimpleTimePicker';
import SimpleSwitch from './SimpleSwitch';
import SimpleRadioButton from './SimpleRadioButton';
import CustomButton from './CustomButton';
import { UploadFileMinos } from 'src/pages/Files/UpaloadFileMinos';
import { IconButton } from './IconButton';
import AutocompleteMultipleInput from './AutocompleteMultipleInput';

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		margin: 0,
	},
	divider: {
		margin: `${theme.spacing(2)}px 0`,
	},
	containerButton: {
		display: 'flex',
		alignItems: 'flex-end',
	},
}));

const UtilInputs = ({
	formValues,
	onValuesChange,
	onKeyPress,
	onBlur,
	inputValues = [],
	width,
	style = {},
}) => {
	const classes = useStyles();

	return (
		<Grid container spacing={2} className={classes.root} style={style}>
			{inputValues.map((filter, i) => {
				if (filter)
					switch (filter.type) {
						case 'text':
							return (
								<Grid
									item
									xs={12}
									sm={6}
									md={filter.column || 12}
									key={filter.name + i}
								>
									<SimpleText
										adjust={filter.adjustable}
										name={filter.name}
										onChange={onValuesChange}
										onKeyPress={onKeyPress}
										onBlur={onBlur}
										value={filter.value || formValues[filter.name]}
										label={filter.label}
										labelPos={filter.labelPos}
										placeholder={filter.placeholder}
										helperText={filter.helperText}
										disabled={filter.disabled}
										width={filter.width || (width && width)}
										multiline={filter.multiline}
										maxLength={filter.maxLength}
										rows={filter.rows}
										required={filter.required}
										autoComplete={filter.autoComplete}
										isPassword={filter.isPassword}
										isNumber={filter.isNumber}
										decimals={filter.decimals}
										style={filter.style}
										adjustable={filter.adjustable}
										containerClass={filter.containerClass}
									/>
								</Grid>
							);
						case 'password':
							return (
								<Grid
									item
									xs={6}
									md={filter.column || 12}
									key={filter.name + i}
								>
									<SimplePassword
										name={filter.name}
										onChange={onValuesChange}
										value={formValues[filter.name]}
										label={filter.label}
										labelPos={filter.labelPos}
										placeholder={filter.placeholder}
										disabled={filter.disabled}
										width={filter.width || (width && width)}
										style={filter.style}
										containerClass={filter.containerClass}
									/>
								</Grid>
							);
						case 'dropdown':
							if (filter.hidden) {
								return <></>;
							}
							return (
								<Grid
									item
									xs={12}
									sm={6}
									md={filter.column || 12}
									key={filter.name + i}
								>
									<SimpleDropdown
										label={filter.label}
										name={filter.name}
										onChange={
											filter.onchange != null
												? () => filter.onchange()
												: onValuesChange
										}
										value={formValues[filter.name]}
										options={filter.options}
										multiple={filter.multiple}
										width={filter.width || (width && width)}
										disabled={filter.disabled}
										labelPos={filter.labelPos}
										style={filter.style}
										containerClass={filter.containerClass}
										autoFocus={
											filter.autoFocus ? filter.autoFocus : false
										}
									/>
								</Grid>
							);
						case 'chip-dropdown':
							return (
								<Grid item md={filter.column || 12} key={filter.name + i}>
									<SimpleChipDropdown
										label={filter.label}
										name={filter.name}
										onChange={onValuesChange}
										value={formValues[filter.name]}
										options={filter.options}
										width={filter.width || (width && width)}
										disabled={filter.disabled}
										labelPos={filter.labelPos}
										style={filter.style}
										containerClass={filter.containerClass}
									/>
								</Grid>
							);
						case 'dropdown-request':
							return (
								<Grid item md={filter.column || 12} key={filter.name + i}>
									<SimpleDropdownRequest
										label={filter.label}
										name={filter.name}
										onChange={onValuesChange}
										value={formValues[filter.name]}
										options={filter.options}
										width={filter.width || (width && width)}
										disabled={filter.disabled}
										labelPos={filter.labelPos}
										requestFunction={filter.requestFunction}
										style={filter.style}
										containerClass={filter.containerClass}
									/>
								</Grid>
							);
						case 'date':
							return (
								<Grid item md={filter.column || 12} key={filter.name + i}>
									<SimpleDate
										label={filter.label}
										name={filter.name}
										onChange={onValuesChange}
										value={formValues[filter.name]}
										width={filter.width || (width && width)}
										disabled={filter.disabled}
										labelPos={filter.labelPos}
										style={filter.style}
										containerClass={filter.containerClass}
									/>
								</Grid>
							);
						case 'date-time':
							return (
								<Grid
									item
									xs={12}
									sm={6}
									md={filter.column || 12}
									key={filter.name + i}
								>
									<SimpleDateTime
										label={filter.label}
										name={filter.name}
										onChange={onValuesChange}
										value={formValues[filter.name]}
										width={filter.width || (width && width)}
										disabled={filter.disabled}
										labelPos={filter.labelPos}
										style={filter.style}
										containerClass={filter.containerClass}
										helper={filter.helper}
									/>
								</Grid>
							);
						case 'time':
							return (
								<Grid item md={filter.column || 12} key={filter.name + i}>
									<SimpleTimePicker
										label={filter.label}
										name={filter.name}
										onChange={onValuesChange}
										value={formValues[filter.name]}
										width={filter.width || (width && width)}
										disabled={filter.disabled}
										labelPos={filter.labelPos}
										style={filter.style}
										containerClass={filter.containerClass}
									/>
								</Grid>
							);
						case 'search':
							return (
								<Grid
									item
									md={filter.column || 12}
									key={filter.type + i}
									style={{ flexBasis: '100%' }}
								>
									<Fragment key={filter.name + i}>
										<SimpleAutocomplete
											name={filter.name}
											label={filter.label}
											value={formValues[filter.name]}
											placeholder={filter.placeholder}
											options={filter.options}
											onChange={onValuesChange}
											searchFunction={filter.searchFunction}
											requestFunction={filter.searchFunction}
											width={filter.width || (width && width)}
											disabled={filter.disabled}
											showAvatars={filter.showAvatars}
											limitTags={filter.limitTags}
										/>
									</Fragment>
								</Grid>
							);
						case 'checkbox':
							return (
								<Grid item md={filter.column || 12} key={filter.name + i}>
									<SimpleCheckbox
										name={filter.name}
										disabled={filter.disabled}
										label={filter.label}
										value={formValues[filter.name]}
										onChange={onValuesChange}
										labelPos={filter.labelPos}
										width={filter.width || (width && width)}
									/>
								</Grid>
							);

						case 'switch':
							return (
								<Grid item md={filter.column || 12} key={filter.name + i}>
									<SimpleSwitch
										name={filter.name}
										disabled={filter.disabled}
										label={filter.label}
										value={formValues[filter.name]}
										onChange={onValuesChange}
										labelPos={filter.labelPos}
										color={filter.color}
									/>
								</Grid>
							);

						case 'radio':
							return (
								<Grid item md={filter.column || 12} key={filter.name + i}>
									<SimpleRadioButton
										name={filter.name}
										disabled={filter.disabled}
										label={filter.label}
										value={formValues[filter.name]}
										onChange={onValuesChange}
										labelPos={filter.labelPos}
										options={filter.options}
										className={filter.className}
									/>
								</Grid>
							);
						case 'button':
							return (
								<Grid
									item
									className={classes.containerButton}
									md={filter.column || 12}
									key={filter.label + i}
								>
									<CustomButton
										mainText={filter.label}
										disabled={filter.disabled}
										onClick={filter.onClick}
										color={filter.color}
										outlined={filter.outlined}
										className={filter.className}
										startIcon={filter.startIcon}
										endIcon={filter.endIcon}
										style={{ ...filter.style }}
									/>
								</Grid>
							);
						case 'icon-button':
							return (
								<Grid
									item
									md={filter.column || 12}
									className={classes.containerButton}
									key={filter.label + i}
								>
									<IconButton
										data={filter.data}
										label={filter.label}
										tooltip={filter.tooltip}
										disabled={filter.disabled}
										onClick={
											filter.data != null
												? () => {
														filter.onClick(filter.data);
												  }
												: filter.onClick
										}
										color={filter.color}
										className={filter.className}
										tooltipPos={filter.tooltipPos}
										style={{ ...filter.style }}
										src={filter.src}
									/>
								</Grid>
							);
						case 'line-break':
							return (
								<Grid
									item
									md={filter.column || 12}
									key={filter.type + i}
									style={{ flexBasis: '100%' }}
								>
									<br />
									{filter.title && (
										<Fragment>
											<Divider fullWitdh />
											<Typography variant="h6">
												{filter.title}
											</Typography>
										</Fragment>
									)}
									{filter.separator && <Divider full />}
								</Grid>
							);
						case 'inner-column':
							return (
								<Grid
									item
									md={filter.column || 12}
									key={filter.type + i}
								/>
							);
						case 'search-multiple':
							return (
								<Grid
									item
									md={filter.column || 12}
									key={filter.type + i}
									style={{ flexBasis: '100%' }}
								>
									<Fragment key={filter.name + i}>
										<AutocompleteMultipleInput
											name={filter.name}
											label={filter.label}
											value={formValues[filter.name]}
											placeholder={filter.placeholder}
											options={filter.options}
											renderOption={filter.renderOption}
											onChange={onValuesChange}
											searchFunction={filter.searchFunction}
											requestFunction={filter.searchFunction}
											width={filter.width || (width && width)}
											disabled={filter.disabled}
											showAvatars={filter.showAvatars}
											limitTags={filter.limitTags}
										/>
									</Fragment>
								</Grid>
							);
						case 'icon-upload_minos':
							return (
								<Grid
									item
									md={filter.column || 12}
									className={classes.containerButton}
									key={filter.label + i}
								>
									<UploadFileMinos
										UploadWhenChanhge={filter.UploadWhenChanhge}
										control={filter.control}
										onUploaded={filter.onUploadedFile}
										idEntidad={filter.data.idEntidad}
										tipo={filter.data.tipo}
										entidad={filter.data.entidad}
										ruta={filter.data.ruta}
										title={filter.data.title}
										nombre={filter.data.nombre}
										typeDownload={filter.data.typeDownload}
										disabled={filter.disabled}
									/>
								</Grid>
							);
						default:
							<></>;
					}
				return false;
			})}
		</Grid>
	);
};

export default UtilInputs;
